import Tooltip from "../../../../../components/shared/Tooltip";
import { cn } from "../../../../../lib/utils";

export interface ItemProps {
    id: string;
    label: string;
    icon: any;
    hidden: boolean;
    disabled: boolean;
    onChange: (value: string) => void;
}

function Item({ id, label, icon, hidden, disabled, onChange }: ItemProps) {
    const Icon = icon;

    if (hidden) return null;

    return (
        <Tooltip
            key={id}
            triggerClassName={cn(
                "tw-cursor-pointer tw-rounded-md tw-border tw-border-neutral-200 tw-bg-white tw-px-3 tw-py-2 tw-text-neutral-700 tw-shadow-none hover:tw-border-primary/20 hover:tw-bg-indigo-50 hover:tw-text-primary tw-transition-colors",
                disabled && "tw-opacity-50 tw-cursor-not-allowed hover:tw-bg-white hover:tw-border-neutral-200 hover:tw-text-neutral-700",
                id === "close" && "tw-text-rose-500 tw-border-rose-200 hover:tw-bg-rose-50 hover:tw-border-rose-300 hover:tw-text-rose-600"
            )}
            trigger={(
                <div onClick={disabled ? undefined : () => onChange(label)}>
                    <Icon width={16} />
                </div>
            )}
        >
            {label}
        </Tooltip>
    );
}

export default Item;
